import { render, staticRenderFns } from "./personalArea.vue?vue&type=template&id=2c7688b2&scoped=true&"
import script from "./personalArea.vue?vue&type=script&lang=js&"
export * from "./personalArea.vue?vue&type=script&lang=js&"
import style0 from "./personalArea.vue?vue&type=style&index=0&id=2c7688b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7688b2",
  null
  
)

export default component.exports